import UploadModal from "./upload"

export default UploadModal
